import { Fragment, useCallback, useEffect } from 'react';

import { toCSV } from 'utils/clickme';
import { VIEW_DATE_WITH_TIME_FORMAT } from 'utils/constants/date';
import { formatDate } from 'utils/date';

import Gap from 'bloko/blocks/gap';
import Loading, { LoadingScale } from 'bloko/blocks/loading';

import useTrls from 'hooks/translation/useTrls';

import Table from 'components/Table';

import Charge from 'components/Admin/InvoiceDetail/Charges/Charge';
import fetchCharges from 'components/Admin/InvoiceDetail/Charges/fetchCharges';
import Header from 'components/Admin/InvoiceDetail/Charges/Header';
import Total from 'components/Admin/InvoiceDetail/Charges/Total';
import Filter, { DEFAULT_FILTER_DATES } from 'components/Admin/InvoiceDetail/Filter';
import TitleWithInvoiceNumber from 'components/Admin/InvoiceDetail/TitleWithInvoiceNumber';
import TableBody from 'components/Table/TableBody';
import TableHead from 'components/Table/TableHead';

import { useDispatch, useSelector } from 'store/utils';

import 'components/Admin/InvoiceDetail/Charges/Charges.less';

const Charges = () => {
    const { invoiceId, invoice, charges, isLoadCharges } = useSelector((state) => state.invoiceDetail);

    const dispatch = useDispatch();

    const trl = useTrls();

    useEffect(() => {
        const dates = DEFAULT_FILTER_DATES(invoice);
        dispatch(fetchCharges(invoiceId, dates.from, dates.to));
    }, [dispatch, invoice, invoiceId]);
    const onCsvClick = useCallback(() => {
        const currentDate = formatDate(new Date(), VIEW_DATE_WITH_TIME_FORMAT);
        const fileName = `charges_${invoiceId}_${currentDate}.csv`;
        const headers = ['date', 'amount', 'bonus'];
        const sum = charges.reduce((sum, { amount }) => sum + amount, 0);
        const total = ['', sum, ''];
        toCSV(fileName, charges, headers, total);
    }, [charges, invoiceId]);
    return (
        <Gap bottom>
            <TitleWithInvoiceNumber
                titleBlock={trl('admin.Invoices.InvoicesDetail.Invoice.Charges.title')}
                {...invoice}
            />
            <Filter invoiceId={invoiceId} fetchItems={fetchCharges} />
            {isLoadCharges && <Loading scale={LoadingScale.Medium} />}
            {!isLoadCharges && charges.length === 0 && (
                <div>{trl('admin.Invoices.InvoicesDetail.Invoice.Charges.empty')}</div>
            )}
            {!isLoadCharges && charges.length > 0 && (
                <Fragment>
                    <div className="csv-import" onClick={onCsvClick}>
                        <span className="csv-import_action">
                            {trl('admin.Invoices.InvoicesDetail.Invoice.Charges.import')}
                        </span>
                    </div>
                    <Table bordered fullWidth withStripes>
                        <TableHead>
                            <Header />
                        </TableHead>
                        <TableBody>
                            {charges.map((charge, index) => (
                                <Charge key={index} {...charge} />
                            ))}
                            <Total charges={charges} />
                        </TableBody>
                    </Table>
                </Fragment>
            )}
        </Gap>
    );
};

export default Charges;
